import { render } from "./chatHistory.vue?vue&type=template&id=2052557c"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"

import "./chatHistory.vue?vue&type=style&index=0&id=2052557c&lang=scss"
script.render = render

export default script